<template>
  <v-container grid-list-xs>
    <v-row justify="center" v-if="UserAccesses.ogol">
      <v-col cols="6">
        <!-- <h2>Fasax uma heesatid page kan</!-->
        <v-card>
          <v-card-title class="green justify-center white--text">
            Acess Pages
          </v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item
                v-for="(item, index) in UserAccesses.ogol"
                :key="index"
                >{{ item }}</v-list-item
              >
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { tokenMixin } from "../Mixins/tokenMixins.js";
export default {
  mixins: [tokenMixin],
  // props: { Accesses: { type: Array, required: true } }
};
</script>
